import EditableInput from '@/components/editable-input'

import { cn } from '@/utils'

import { RundownPermission } from '~shared/rundown/permission'

import { useRundown } from '@/features/rundown/rundown.derived'

import { useRundownAccess } from '../../permissions/lib/use-rundown-access'
import { rundownActions } from '../rundown.actions'

export function RundownNavbarName() {
  const rundown = useRundown()

  const { hasPermission } = useRundownAccess()
  const canEdit = hasPermission(RundownPermission.EDIT)

  const handleRundownRename = async (newName: string) => {
    await rundownActions.rename(rundown.id, newName)
  }

  return (
    <EditableInput
      className={cn(
        'text-sm whitespace-pre truncate min-w-20 max-w-75',
        canEdit && 'h-7 px-2 hover:bg-gray-900 focus:bg-gray-900',
      )}
      value={rundown.name}
      onChange={handleRundownRename}
      disabled={!canEdit}
      required
    />
  )
}
